import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    //{ path: '', redirectTo: 'access_denied', pathMatch: 'full' },
    {
        path: 'access_denied',
        loadChildren: () => import('./access-denied/access-denied.module').then(module => module.AccessDeniedModule),
    },
    {
        path: 'security-check',
        loadChildren: () => import('./security-check/security-check.module').then(module => module.SecurityCheckModule),
    },
    {
        path: 'consent-page',
        loadChildren: () => import('./consent-page/consent-page.module').then(module => module.ConsentPageModule),
    },
    {
        path: 'survey/final',
        loadChildren: () => import('./survey-final/survey-final.module').then(module => module.SurveyFinalModule),
    },
    {
        path: 'survey/closed',
        loadChildren: () => import('./survey-closed/survey-closed.module').then(module => module.SurveyClosedModule),
    },
    {
        path: 'survey/pii',
        loadChildren: () => import('./survey-pii/survey-pii.module').then(module => module.SurveyPiiModule),
    },
    {
        path: 'survey/sms_verification',
        loadChildren: () => import('./survey-sms-verification/survey-sms-verification.module').then(module => module.SurveySmsVerificationModule),
    },
    {
        path: 'survey/:questionType',
        loadChildren: () => import('./survey/survey.module').then(module => module.SurveyModule),
    },
    {
        path: 'security-check-all',
        loadChildren: () => import('./security-check-2/security-check-2.module').then(module => module.SecurityCheck2Module),
    },
    {
        path: 'survey-satisfaction',
        loadChildren: () => import('./survey-satisfaction/survey-satisfaction.module').then(module => module.SurveySatisfactionModule),
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
